
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'SocialSharing',
	components: {},
	computed: {
		mailBody() {
			if (this.text) {
				return `${this.text}<br />${this.link}`;
			}
			return this.link;
		}
	},
	props: {
		title: { type: String, default: 'hokify.at - die größte mobile Job-Plattform' },
		text: { type: String, default: '' },
		link: { type: String, default: '' }
	}
});
